export default __webpack_public_path__ + "static/media/expand-collapse-grey.e5f54613.svg";